<div class="dpm-static mam-static">
  <hr class="line" [ngStyle]="{ background: newColor }" />

  <!-- The shared header, as on DPM-Static. No brand filter here, so
       publishTopnavContext() clears its brand label. -->
  <app-topnav
    [clientLogo]="clientLogo"
    [pagename]="dashboardTitle"
    [refreshTheDashboard]="false"
    [widgetHelpInfo]="topnavHelpInfo"
  ></app-topnav>

  <div class="dpm-body">
    <!-- ============================ FILTER BAR ============================
         Same strip as DPM-Static: a chip per filter (once it has values), the
         applied/total count going amber when the chip is off its default (the
         Payer hierarchy reads "All" while every node is selected), the Date
         badge, scroll arrows when the chips overflow, and Reset when anything
         is narrowed. -->
    <div class="filter-bar">
      <span class="sf-label">Selected filters:</span>

      <span class="sf-nav" *ngIf="badgesOverflow" (click)="scrollBadges(-1)" title="Scroll left">
        <svg width="16" height="16" viewBox="0 0 8 8" fill="none">
          <path
            d="M6.79059 7.11381C6.81139 7.06178 6.79965 7.00195 6.76179 6.96215L3.92262 3.99979L6.76151 1.03744C6.79965 0.997648 6.81111 0.93727 6.79058 0.885787C6.77005 0.833757 6.72125 0.799805 6.66739 0.799805L4.26742 0.799805C4.23196 0.799805 4.19808 0.814557 4.17302 0.840435L1.23972 3.9013C1.21386 3.92857 1.20078 3.96418 1.20078 3.9998C1.20078 4.03543 1.21384 4.07103 1.23972 4.09831L4.17302 7.15917C4.19808 7.18505 4.23196 7.1998 4.26742 7.1998L6.66739 7.1998C6.72125 7.19979 6.77005 7.16584 6.79059 7.11381Z"
            fill="#1363DF"
          />
        </svg>
      </span>

      <div class="badge-scroller" #badgeScroller>
        <ng-container *ngFor="let f of filters; trackBy: trackFilter">
          <div class="chip" *ngIf="hasOptions(f)">
            <div class="chip-toggle" (click)="toggleDropdown(f, $event)">
              <span class="chip-label mr-1">{{ f.label }}</span>
              <span
                class="chip-count"
                [style.background]="isPartial(f) ? '#FF9A3D' : '#1363df'"
                >{{ chipValue(f) }}</span
              >
              <span class="chip-caret">▾</span>
            </div>
          </div>
        </ng-container>

        <!-- Date, as DPM-Static's date badge: the range itself, amber once moved
             off its default. -->
        <div class="chip" *ngIf="quarters.length" (click)="togglePeriod($event)">
          <span class="chip-label date-chip" [class.date-chip-on]="periodPartial">{{
            periodLabel(period)
          }}</span>
          <span class="chip-caret">▾</span>
        </div>
      </div>

      <span class="sf-nav" *ngIf="badgesOverflow" (click)="scrollBadges(1)" title="Scroll right">
        <svg width="16" height="16" viewBox="0 0 8 8" fill="none">
          <path
            d="M1.20941 7.11381C1.18861 7.06178 1.20035 7.00195 1.23821 6.96215L4.07738 3.99979L1.23849 1.03744C1.20035 0.997648 1.18889 0.93727 1.20942 0.885787C1.22995 0.833757 1.27875 0.799805 1.33261 0.799805L3.73258 0.799805C3.76804 0.799805 3.80192 0.814557 3.82698 0.840435L6.76028 3.9013C6.78614 3.92857 6.79922 3.96418 6.79922 3.9998C6.79922 4.03543 6.78616 4.07103 6.76028 4.09831L3.82698 7.15917C3.80192 7.18505 3.76804 7.1998 3.73258 7.1998L1.33261 7.1998C1.27875 7.19979 1.22995 7.16584 1.20941 7.11381Z"
            fill="#1363DF"
          />
        </svg>
      </span>

      <span class="chip reset-chip" *ngIf="anyPartial" (click)="resetFilters()" title="Reset all filters">
        <mat-icon class="reset-icon" svgIcon="x_mark"></mat-icon>Reset
      </span>
    </div>

    <!-- Fixed dropdown for the open chip (outside the scroller so it is not clipped).
         Opened from the side panel too, so it sits above the panel while that is open. -->
    <div
      class="filter-backdrop"
      *ngIf="openFilter || periodOpen"
      [class.over-panel]="filterPanelOpen"
      (click)="closeDropdown()"
    ></div>
    <div
      class="badge-menu"
      *ngIf="openFilter as f"
      [class.tree-menu]="f.kind === 'tree'"
      [class.over-panel]="filterPanelOpen"
      [style.left.px]="menuPos.left"
      [style.top.px]="menuPos.top"
      (click)="$event.stopPropagation()"
    >
      <ng-container *ngTemplateOutlet="filterControls; context: { f: f }"></ng-container>
    </div>

    <!-- Date: a From / To range of quarters, committed on Apply. -->
    <div
      class="badge-menu period-menu mam-set"
      *ngIf="periodOpen"
      [class.over-panel]="filterPanelOpen"
      [style.left.px]="menuPos.left"
      [style.top.px]="menuPos.top"
      (click)="$event.stopPropagation()"
    >
      <div class="period-body">
        <div class="period-title">Quarter range</div>
        <label class="period-field">
          <span>From</span>
          <select
            class="period-select"
            [ngModel]="pendingPeriod.start"
            (ngModelChange)="onPendingStart($event)"
          >
            <option *ngFor="let q of quarters" [value]="q.key">{{ q.label }}</option>
          </select>
        </label>
        <label class="period-field">
          <span>To</span>
          <select class="period-select" [(ngModel)]="pendingPeriod.end">
            <option *ngFor="let q of endQuarters" [value]="q.key">{{ q.label }}</option>
          </select>
        </label>
        <div class="period-hint">
          Coverage panels read the latest MMIT snapshot on or before the period end:
          <b>{{ pendingSnapshot }}</b>
        </div>
      </div>
      <div class="mam-set-foot period-foot">
        <button type="button" class="mam-btn mam-btn-ghost" (click)="closeDropdown()">Cancel</button>
        <button type="button" class="mam-btn mam-btn-primary" (click)="applyPeriod()">Apply</button>
      </div>
    </div>

    <!-- Include / Exclude / Clear — shared by the chip dropdown and the panel. -->
    <ng-template #ieButtons let-f="f" let-sc="sc">
      <button
        class="btn include du-multi-select-btn"
        [class.disabled]="!canInclude(f)"
        [disabled]="!canInclude(f)"
        title="Include"
        (click)="$event.stopPropagation(); applyInclude(f, sc)"
      >
        <svg width="25" height="15" viewBox="0 0 15 15" fill="none">
          <rect x="7" width="8" height="3" fill="#1363DF" />
          <rect x="7" y="12" width="8" height="3" fill="#1363DF" />
          <path
            d="M6.15338 6.46002L-5.28031e-07 6.46003L-3.46196e-07 8.53998L6.15338 8.53998L3.76241 11.0228L5.18496 12.5L10 7.5L5.18496 2.5L3.76241 3.9772L6.15338 6.46002Z"
            fill="#1363DF"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M6.62947 4L9.5185 7H5V6.46003L6.15338 6.46002L5 5.26233V4H6.62947ZM8.01778 4H13V7H10.8663C10.8265 6.93118 10.7778 6.86608 10.7203 6.80634L8.01778 4Z"
            fill="#1363DF"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M9.5185 8L6.62947 11H6V8.69925L6.15338 8.53998H6V8H9.5185ZM10.8663 8H14V11H8.01778L10.7203 8.19366C10.7778 8.13392 10.8265 8.06882 10.8663 8Z"
            fill="#1363DF"
          />
        </svg>
      </button>

      <button
        class="btn exclude du-multi-select-btn"
        [class.disabled]="!canExclude(f)"
        [disabled]="!canExclude(f)"
        title="Exclude"
        (click)="$event.stopPropagation(); applyExclude(f, sc)"
      >
        <svg width="25" height="15" viewBox="0 0 15 15" fill="none">
          <rect width="8" height="3" fill="#D11044" />
          <rect y="12" width="8" height="3" fill="#D11044" />
          <path
            d="M11.1534 6.46002L5 6.46003L5 8.53998L11.1534 8.53998L8.76241 11.0228L10.185 12.5L15 7.5L10.185 2.5L8.76241 3.9772L11.1534 6.46002Z"
            fill="#D11044"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M5 7H10V6.46003L5 6.46003V7ZM10 5.26234L8.78436 4H10V5.26234ZM4 7H2V4H7.76266C7.76816 4.24237 7.86131 4.48312 8.0421 4.67086L8.80207 5.46003L5 5.46003C4.44772 5.46003 4 5.90774 4 6.46003V7Z"
            fill="#D11044"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M8.78436 11H9V10.7761L8.78436 11ZM9 8.53998L5 8.53998V8H9V8.53998ZM7.76267 11H1V8H4V8.53998C4 9.09226 4.44772 9.53997 5 9.53998L8.80207 9.53998L8.0421 10.3291C7.86131 10.5169 7.76816 10.7576 7.76267 11Z"
            fill="#D11044"
          />
        </svg>
      </button>

      <button
        class="btn exclude du-multi-select-btn"
        [class.disabled]="!canClear(f)"
        [disabled]="!canClear(f)"
        title="Clear selection"
        (click)="$event.stopPropagation(); applyClear(f, sc)"
      >
        <svg width="25" height="15" viewBox="0 0 16 16" fill="none">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M15.1233 0C15.6075 0 16 0.392499 16 0.876682C16 1.05902 15.9432 1.23684 15.8373 1.3854L12.2592 6.40765C11.9677 6.35237 11.6669 6.32344 11.3594 6.32344C8.70842 6.32344 6.55938 8.47248 6.55938 11.1234C6.55938 12.7503 7.3687 14.1881 8.60667 15.0562L7.97832 15.4751C7.19837 15.995 6.14461 15.7843 5.62468 15.0044C5.43971 14.7268 5.34054 14.401 5.33964 14.0675L5.32513 8.72486L0.159683 1.38108C-0.11886 0.985049 -0.0236423 0.438156 0.372391 0.159613C0.520046 0.055766 0.696221 0 0.876751 0H15.1233Z"
            fill="#D11044"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M11.2 14.3219C12.9673 14.3219 14.4 12.8892 14.4 11.1219C14.4 9.35456 12.9673 7.92188 11.2 7.92188C9.43269 7.92188 8 9.35456 8 11.1219C8 12.8892 9.43269 14.3219 11.2 14.3219ZM11.5953 11.4889H12.8V10.7642H11.5953L11.6 10.7643H10.8L10.7953 10.7642H9.60001V11.4889L10.7953 11.4889L11.5953 11.4889Z"
            fill="#D11044"
          />
        </svg>
      </button>
    </ng-template>

    <!-- The chip dropdown's body (search, Select All, Add current, options).
         A tree chip (Payer) draws its nodes nested, a display chip (Therapeutic
         Class) just states what is in scope. -->
    <ng-template #filterControls let-f="f">
      <div class="filter-controls" *ngIf="f.kind === 'display'">
        <div class="display-body">
          <div class="du-badge-option selected display-option" *ngFor="let o of f.options">
            <input type="checkbox" checked disabled />
            <span>{{ o }}</span>
          </div>
          <div class="display-note" *ngIf="f.note">{{ f.note }}</div>
        </div>
      </div>

      <div class="filter-controls" *ngIf="f.kind !== 'display'">
        <div class="header" *ngIf="!f.single">
          <ng-container *ngTemplateOutlet="ieButtons; context: { f: f }"></ng-container>
        </div>

        <div class="search-container">
          <input class="search-bar" type="text" placeholder="Search..." [(ngModel)]="f.search" />
        </div>

        <div class="select-all-container" *ngIf="!f.single" (click)="toggleSelectAll(f, $event)">
          <input type="checkbox" [checked]="allChecked(f)" (click)="toggleSelectAll(f, $event)" />
          <span *ngIf="!f.search">Select All</span>
          <span *ngIf="f.search">(Select All Search Results)</span>
        </div>

        <div class="select-all-container" *ngIf="!f.single" (click)="toggleAddCurrent(f, $event)">
          <input type="checkbox" [checked]="f.addCurrent" (click)="toggleAddCurrent(f, $event)" />
          <span>Add current selection to filter</span>
        </div>

        <!-- Tree: a row per visible node, indented by depth, caret on the right. -->
        <div class="menu-options tree-options" *ngIf="f.kind === 'tree'">
          <ng-container *ngIf="treeRows(f) as rows">
            <div
              class="du-badge-option tree-row"
              *ngFor="let row of rows; trackBy: trackTreeRow"
              [class.selected]="row.state === 'all'"
              [style.padding-left.px]="10 + row.node.depth * 24"
              [title]="row.node.id"
              (click)="toggleNode(f, row.node, $event)"
            >
              <input
                type="checkbox"
                [checked]="row.state === 'all'"
                [indeterminate]="row.state === 'some'"
                (click)="toggleNode(f, row.node, $event)"
              />
              <span class="tree-label">
                {{ row.node.label }}<span class="tree-tag" *ngIf="row.tag"> {{ row.tag }}</span>
              </span>
              <button
                type="button"
                class="tree-caret"
                *ngIf="row.node.children.length"
                [class.open]="row.open"
                [attr.aria-expanded]="row.open"
                [attr.aria-label]="(row.open ? 'Collapse ' : 'Expand ') + row.node.label"
                (click)="toggleExpand(f, row.node, $event)"
              >
                <svg width="12" height="12" viewBox="0 0 12 12" fill="none" aria-hidden="true">
                  <path d="M3 4.5L6 7.5L9 4.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
              </button>
            </div>
            <div class="no-data" *ngIf="rows.length === 0">No data found</div>
          </ng-container>
        </div>

        <div
          class="menu-options"
          *ngIf="f.kind === 'list'"
          [class.dynamicHeight]="filteredOptions(f).length > 9"
        >
          <div
            class="du-badge-option"
            *ngFor="let o of filteredOptions(f)"
            [class.selected]="isChecked(f, o)"
            (click)="toggleOption(f, o, $event)"
          >
            <input type="checkbox" [checked]="isChecked(f, o)" (click)="toggleOption(f, o, $event)" />
            <span>{{ o }}</span>
          </div>
          <div class="no-data" *ngIf="filteredOptions(f).length === 0">No data found</div>
        </div>
      </div>
    </ng-template>

    <!-- ============================== PAGES =============================== -->
    <div class="mam-tabs" role="tablist">
      <button
        type="button"
        role="tab"
        class="mam-tab"
        *ngFor="let p of pages; let i = index"
        [class.active]="i === activePage"
        [attr.aria-selected]="i === activePage"
        [style.z-index]="i === activePage ? pages.length + 1 : pages.length - i"
        (click)="selectPage(i)"
      >
        <!-- The tab shape: rounded left, curved slant on the right. Stretched to
             the label's width; the stroke stays 1.6px (non-scaling). -->
        <svg
          class="mam-tab-shape"
          viewBox="98.131 168.337 199.483 47.954"
          preserveAspectRatio="none"
          aria-hidden="true"
        >
          <g transform="matrix(1.454693, 0, 0, 1.00074, 84.396833, 158.40268)">
            <path
              d="M 10.5 18.318 C 10.5 14.315 13.219 11.068 16.572 11.068 L 127.573 11.068 C 129.959 11.068 132.122 12.737 133.105 15.331 L 144.823 46.263 C 146.64 51.061 143.703 56.5 139.291 56.5 L 16.572 56.5 C 13.219 56.5 10.5 53.254 10.5 49.25 L 10.5 18.318 Z"
              vector-effect="non-scaling-stroke"
            />
          </g>
        </svg>
        <span class="mam-tab-label">{{ p.title }}</span>
      </button>
    </div>

    <div class="dpm-scroll">
      <!-- ============ PAGE 1 — Coverage by Payer/PBM and Drug ============ -->
      <ng-container *ngIf="pages[activePage]?.key === 'coverage'">
        <div
          class="panel mam-card"
          *ngFor="let c of cards; trackBy: trackCard"
          [attr.data-card-id]="c.widget.id"
          [class.is-fullscreen]="fullscreenId === c.widget.id"
        >
          <!-- Header: title | Show by + grouping | icons -->
          <div class="mam-head">
            <div class="mam-title">{{ c.widget.title }}</div>

            <div class="mam-controls">
              <!-- icon-chart's `show_by` header control, markup for markup. -->
              <div class="showByContainer align-items-center w-auto" style="text-align: center">
                <div class="sort_by_styles d-flex">
                  <label class="sort_by_texts mt-2" style="border-right: 2px solid #e8eaee"
                    >Show by&nbsp;&nbsp;</label
                  >
                  <mat-select
                    class="sort_by_select text-center"
                    panelClass="show-by-panel"
                    hideSingleSelectionIndicator
                    [ngModel]="c.showBy"
                    (ngModelChange)="onShowByChange(c, $event)"
                  >
                    <mat-option
                      *ngFor="let o of showByOptions"
                      [value]="o.value"
                      class="dropdown_values"
                      >{{ o.title }}</mat-option
                    >
                  </mat-select>
                </div>
              </div>

              <label class="mam-check" *ngIf="c.showBy === 'group3l'">
                <input
                  type="checkbox"
                  [checked]="c.grouped"
                  (change)="onGroupedChange(c, $any($event.target).checked)"
                />
                <span>Group 3L and above as 3L+</span>
              </label>
            </div>

            <div class="mam-icons">
              <mat-icon
                *ngIf="c.help"
                class="matIcons"
                svgIcon="info_circle"
                matTooltip="Help"
                [matMenuTriggerFor]="cardHelpMenu"
                (click)="showCardHelp(c)"
              ></mat-icon>

              <!-- Settings: X axis / Y axis, committed on Apply. -->
              <mat-icon
                class="matIcons"
                svgIcon="select_setting"
                matTooltip="Settings"
                #setTrig="matMenuTrigger"
                [matMenuTriggerFor]="setMenu"
                (menuOpened)="openSettings(c)"
              ></mat-icon>
              <mat-menu #setMenu="matMenu" class="mam-settings-menu" xPosition="before">
                <div
                  class="mam-set"
                  (click)="$event.stopPropagation()"
                  (keydown)="$event.stopPropagation()"
                >
                  <div class="mam-set-head">
                    <span class="mam-set-title">Settings</span>
                    <button
                      type="button"
                      class="mam-set-x"
                      title="Close"
                      (click)="setTrig.closeMenu()"
                    >
                      <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
                        <path d="M1 1L11 11M11 1L1 11" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" />
                      </svg>
                    </button>
                  </div>

                  <div class="mam-set-sec">X axis</div>
                  <label class="mam-radio" *ngFor="let o of xAxisOptions">
                    <input
                      type="radio"
                      [name]="'mam-x-' + c.widget.id"
                      [checked]="c.pendingX === o.key"
                      (change)="c.pendingX = o.key"
                    />
                    <span>{{ o.label }}</span>
                  </label>

                  <div class="mam-set-sec">Y axis</div>
                  <label class="mam-radio" *ngFor="let o of yAxisOptions">
                    <input
                      type="radio"
                      [name]="'mam-y-' + c.widget.id"
                      [checked]="c.pendingY === o.key"
                      (change)="c.pendingY = o.key"
                    />
                    <span>{{ o.label }}</span>
                  </label>

                  <div class="mam-set-foot">
                    <button type="button" class="mam-btn mam-btn-ghost" (click)="setTrig.closeMenu()">
                      Cancel
                    </button>
                    <button
                      type="button"
                      class="mam-btn mam-btn-primary"
                      (click)="applySettings(c); setTrig.closeMenu()"
                    >
                      Apply
                    </button>
                  </div>
                </div>
              </mat-menu>

              <!-- Export menu: the same icon, menu class and item icons as the
                   dynamic widgets' header (icon-chart's dotmenu_circle). -->
              <mat-icon
                class="matIcons"
                svgIcon="dotmenu_circle"
                matTooltip="Export"
                [matMenuTriggerFor]="exportMenu"
              ></mat-icon>
              <mat-menu #exportMenu="matMenu" class="chart-export-menu mam-export-menu" xPosition="before">
                <button
                  mat-menu-item
                  [disabled]="loading || !c.rows.length || !!outOfScopeFilter(c)"
                  (click)="exportExcel(c)"
                >
                  <mat-icon svgIcon="xls"></mat-icon>
                  <span>Export to Excel</span>
                </button>
                <button
                  mat-menu-item
                  [disabled]="loading"
                  (click)="exportImage(c)"
                >
                  <mat-icon svgIcon="png"></mat-icon>
                  <span>Export to Image</span>
                </button>
              </mat-menu>

              <mat-icon
                class="matIcons"
                [svgIcon]="fullscreenId === c.widget.id ? 'collapse_arrow' : 'expand_circle'"
                [matTooltip]="fullscreenId === c.widget.id ? 'Exit Full Screen' : 'Show Full Screen'"
                (click)="toggleFullscreen(c)"
              ></mat-icon>
            </div>
          </div>

          <div class="panel-state" *ngIf="loading">
            <app-progress-indefinite></app-progress-indefinite>
          </div>

          <!-- Filtered out of scope (e.g. its indication excluded by the
               Indication chip): the card stays, the legend and chart give way to
               the same "no data" message every widget uses. -->
          <div class="panel-state" *ngIf="!loading && outOfScopeFilter(c) as fLabel">
            <span class="bg-text">There is no data for the selected {{ fLabel }}</span>
          </div>

          <ng-container *ngIf="!loading && !outOfScopeFilter(c)">
            <!-- Legend: click a series to show / hide it. -->
            <div class="legend-row mam-legend">
              <span class="legend-prefix" *ngIf="c.widget.legendTitle">{{ c.widget.legendTitle }}</span>
              <span
                class="mam-lg-item"
                *ngFor="let l of c.legend; trackBy: trackLegend"
                [class.off]="c.hidden.has(l.key)"
                (click)="toggleSeries(c, l.key)"
              >
                <span
                  class="mam-lg-swatch"
                  [style.background]="c.hidden.has(l.key) ? 'transparent' : l.swatch"
                  [style.border-color]="c.hidden.has(l.key) ? '#b0b0b0' : 'transparent'"
                ></span>
                {{ l.label }}
              </span>
            </div>

            <app-moonlake-waterfall-chart
              [data]="c.rows"
              [config]="c.config"
              [hiddenKeys]="c.hidden"
              (viewChange)="fullscreenId === c.widget.id && refitFullView()"
            ></app-moonlake-waterfall-chart>
          </ng-container>
        </div>
      </ng-container>

      <!-- ================== PAGE 2 — Access & Coverage ================== -->
      <ng-container *ngIf="pages[activePage]?.key === 'access'">
        <!-- KPI row: lives-weighted rates for the focus brand (DPM-Static's
             .kpi-card: icon, figure, label, help in the corner). -->
        <div class="mam-kpi-row">
          <ng-container *ngFor="let k of kpis; trackBy: trackKpi">
            <ng-container *ngTemplateOutlet="kpiTpl; context: { $implicit: k }"></ng-container>
          </ng-container>
        </div>

        <ng-container *ngFor="let c of seriesCards; trackBy: trackCard">
          <ng-container *ngTemplateOutlet="seriesCardTpl; context: { $implicit: c }"></ng-container>
        </ng-container>
      </ng-container>

      <!-- ================ PAGE 3 — Competitive Position ================ -->
      <ng-container *ngIf="pages[activePage]?.key === 'competitive'">
        <ng-container *ngFor="let c of parityCards; trackBy: trackCard">
          <ng-container *ngTemplateOutlet="stackedCardTpl; context: { $implicit: c }"></ng-container>
        </ng-container>

        <!-- Step-through requirements for one drug, plan by plan. -->
        <div class="panel mam-card mam-table-card" [attr.data-card-id]="stepTable.id">
          <div class="mam-head">
            <div class="mam-title">{{ stepTable.title }}</div>

            <div class="mam-controls">
              <div class="showByContainer align-items-center w-auto" style="text-align: center">
                <div class="sort_by_styles d-flex">
                  <label class="sort_by_texts mt-2" style="border-right: 2px solid #e8eaee"
                    >Drug&nbsp;&nbsp;</label
                  >
                  <mat-select
                    class="sort_by_select text-center"
                    panelClass="show-by-panel"
                    hideSingleSelectionIndicator
                    [ngModel]="stepDrug"
                    (ngModelChange)="onStepDrugChange($event)"
                  >
                    <mat-option *ngFor="let d of stepDrugOptions" [value]="d" class="dropdown_values">{{
                      d
                    }}</mat-option>
                  </mat-select>
                </div>
              </div>
            </div>

            <div class="mam-icons">
              <mat-icon
                *ngIf="stepHelp"
                class="matIcons"
                svgIcon="info_circle"
                matTooltip="Help"
                [matMenuTriggerFor]="cardHelpMenu"
                (click)="showCardHelp({ help: stepHelp })"
              ></mat-icon>
              <mat-icon
                class="matIcons"
                svgIcon="dotmenu_circle"
                matTooltip="Export"
                [matMenuTriggerFor]="stepExportMenu"
              ></mat-icon>
              <mat-menu #stepExportMenu="matMenu" class="chart-export-menu mam-export-menu" xPosition="before">
                <button mat-menu-item [disabled]="loading || !stepRows.length" (click)="exportStepTable()">
                  <mat-icon svgIcon="xls"></mat-icon>
                  <span>Export to Excel</span>
                </button>
              </mat-menu>
            </div>
          </div>

          <div class="panel-state" *ngIf="loading">
            <app-progress-indefinite></app-progress-indefinite>
          </div>

          <div class="panel-state" *ngIf="!loading && !stepRows.length">
            <span class="bg-text">There is no data for this selection</span>
          </div>

          <div class="mam-table-wrap" *ngIf="!loading && stepRows.length">
            <table class="mam-table">
              <thead>
                <tr>
                  <th>Plan / Formulary</th>
                  <th *ngIf="stepShowIndication">Indication</th>
                  <th>Lives</th>
                  <th>Coverage</th>
                  <th class="center">Access Position</th>
                  <th>Step-Through Requirement (MMIT Text)</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  *ngFor="
                    let r of stepRows | slice: stepPager.index * stepPager.size : (stepPager.index + 1) * stepPager.size;
                    trackBy: trackStepRow
                  "
                  [title]="r.path"
                >
                  <td>
                    <span class="mam-td-muted">{{ r.controller }} — </span>{{ r.planFormulary }}
                  </td>
                  <td *ngIf="stepShowIndication">{{ r.indication }}</td>
                  <td>{{ r.lives | number }}</td>
                  <td>{{ r.coverage }}</td>
                  <td class="center">{{ r.position }}</td>
                  <td>{{ r.stepText }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <ng-container
            *ngIf="!loading && stepRows.length"
            [ngTemplateOutlet]="pagerTpl"
            [ngTemplateOutletContext]="{ $implicit: stepPager, total: stepRows.length }"
          ></ng-container>
        </div>
      </ng-container>

      <!-- ================ PAGE 4 — Real-World Evidence ================ -->
      <ng-container *ngIf="pages[activePage]?.key === 'rwe'">
        <div class="mam-kpi-row">
          <ng-container *ngFor="let k of rweKpis; trackBy: trackKpi">
            <ng-container *ngTemplateOutlet="kpiTpl; context: { $implicit: k }"></ng-container>
          </ng-container>
        </div>

        <!-- The access index beside the plans' restriction index. -->
        <div class="mam-split">
          <div class="mam-split-main">
            <ng-container *ngTemplateOutlet="seriesCardTpl; context: { $implicit: rweIndexCard }"></ng-container>
          </div>

          <div class="panel mam-card mam-table-card mam-split-side" [attr.data-card-id]="restrictionTable.id">
            <div class="mam-head">
              <div class="mam-title">{{ restrictionTable.title }}</div>
              <div class="mam-controls"></div>

              <div class="mam-icons">
                <mat-icon
                  *ngIf="restrictionHelp"
                  class="matIcons"
                  svgIcon="info_circle"
                  matTooltip="Help"
                  [matMenuTriggerFor]="cardHelpMenu"
                  (click)="showCardHelp({ help: restrictionHelp })"
                ></mat-icon>
                <mat-icon
                  class="matIcons"
                  svgIcon="dotmenu_circle"
                  matTooltip="Export"
                  [matMenuTriggerFor]="restrictionExportMenu"
                ></mat-icon>
                <mat-menu #restrictionExportMenu="matMenu" class="chart-export-menu mam-export-menu" xPosition="before">
                  <button
                    mat-menu-item
                    [disabled]="loading || !restrictionRows.length"
                    (click)="exportRestrictionTable()"
                  >
                    <mat-icon svgIcon="xls"></mat-icon>
                    <span>Export to Excel</span>
                  </button>
                </mat-menu>
              </div>
            </div>

            <div class="panel-state" *ngIf="loading">
              <app-progress-indefinite></app-progress-indefinite>
            </div>

            <div class="panel-state" *ngIf="!loading && !restrictionRows.length">
              <span class="bg-text">There is no data for this selection</span>
            </div>

            <div class="mam-table-wrap" *ngIf="!loading && restrictionRows.length">
              <table class="mam-table">
                <thead>
                  <tr>
                    <th>Plan</th>
                    <th class="center">Restriction Index</th>
                    <th>MMIT Status</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    *ngFor="
                      let r of restrictionRows
                        | slice: restrictionPager.index * restrictionPager.size : (restrictionPager.index + 1) * restrictionPager.size;
                      trackBy: trackRestrictionRow
                    "
                    [title]="r.path"
                  >
                    <td>{{ r.plan }}</td>
                    <td class="center">{{ r.index | number: "1.2-2" }}</td>
                    <td>{{ r.status }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <ng-container
              *ngIf="!loading && restrictionRows.length"
              [ngTemplateOutlet]="pagerTpl"
              [ngTemplateOutletContext]="{ $implicit: restrictionPager, total: restrictionRows.length }"
            ></ng-container>
          </div>
        </div>

        <ng-container *ngFor="let c of shareCardsOn('rwe'); trackBy: trackCard">
          <ng-container *ngTemplateOutlet="stackedCardTpl; context: { $implicit: c }"></ng-container>
        </ng-container>

        <ng-container *ngTemplateOutlet="seriesCardTpl; context: { $implicit: rweSwitchCard }"></ng-container>
      </ng-container>

      <!-- ============== PAGE 5 — Utilization Management ============== -->
      <ng-container *ngIf="pages[activePage]?.key === 'um'">
        <!-- The two formulary tables side by side, as page 4's split row. -->
        <div class="mam-split">
          <ng-container *ngFor="let t of formularyTables; trackBy: trackFormularyTable">
            <div
              class="panel mam-card mam-table-card"
              [class.mam-split-side]="t.cfg.layout === 'side'"
              [class.mam-split-wide]="t.cfg.layout === 'wide'"
              [attr.data-card-id]="t.cfg.id"
            >
              <div class="mam-head">
                <div class="mam-title">{{ t.cfg.title }}</div>

                <div class="mam-controls">
                  <div class="showByContainer align-items-center w-auto" style="text-align: center">
                    <div class="sort_by_styles d-flex">
                      <label class="sort_by_texts mt-2" style="border-right: 2px solid #e8eaee"
                        >Drug&nbsp;&nbsp;</label
                      >
                      <mat-select
                        class="sort_by_select text-center"
                        panelClass="show-by-panel"
                        hideSingleSelectionIndicator
                        [ngModel]="t.drug"
                        (ngModelChange)="onFormularyTableDrugChange(t, $event)"
                      >
                        <mat-option *ngFor="let d of t.drugOptions" [value]="d" class="dropdown_values">{{
                          d
                        }}</mat-option>
                      </mat-select>
                    </div>
                  </div>
                </div>

                <div class="mam-icons">
                  <mat-icon
                    *ngIf="t.help"
                    class="matIcons"
                    svgIcon="info_circle"
                    matTooltip="Help"
                    [matMenuTriggerFor]="cardHelpMenu"
                    (click)="showCardHelp(t)"
                  ></mat-icon>
                  <mat-icon
                    class="matIcons"
                    svgIcon="dotmenu_circle"
                    matTooltip="Export"
                    [matMenuTriggerFor]="ftExportMenu"
                  ></mat-icon>
                  <mat-menu #ftExportMenu="matMenu" class="chart-export-menu mam-export-menu" xPosition="before">
                    <button mat-menu-item [disabled]="loading || !t.rows.length" (click)="exportFormularyTable(t)">
                      <mat-icon svgIcon="xls"></mat-icon>
                      <span>Export to Excel</span>
                    </button>
                  </mat-menu>
                </div>
              </div>

              <div class="panel-state" *ngIf="loading">
                <app-progress-indefinite></app-progress-indefinite>
              </div>

              <div class="panel-state" *ngIf="!loading && !t.rows.length">
                <span class="bg-text">There is no data for this selection</span>
              </div>

              <div class="mam-table-wrap" *ngIf="!loading && t.rows.length">
                <table class="mam-table">
                  <thead>
                    <tr>
                      <th *ngFor="let col of t.cfg.columns" [class.center]="col.align === 'center'">{{ col.header }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      *ngFor="
                        let r of t.rows | slice: t.pager.index * t.pager.size : (t.pager.index + 1) * t.pager.size;
                        trackBy: trackFormularyRow
                      "
                      [title]="r.title"
                    >
                      <td *ngFor="let col of t.cfg.columns" [class.center]="col.align === 'center'">
                        {{ r.cells[col.key] }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <ng-container
                *ngIf="!loading && t.rows.length"
                [ngTemplateOutlet]="pagerTpl"
                [ngTemplateOutletContext]="{ $implicit: t.pager, total: t.rows.length }"
              ></ng-container>
            </div>
          </ng-container>
        </div>

        <ng-container *ngFor="let c of shareCardsOn('um'); trackBy: trackCard">
          <ng-container *ngTemplateOutlet="stackedCardTpl; context: { $implicit: c }"></ng-container>
        </ng-container>
      </ng-container>

      <!-- ===== Card templates, shared across pages ===== -->
      <!-- Grid paging, laid out as the app's ag-grid paging panel: Page Size,
           "1 to 10 of 34", then first / previous / Page 1 of 4 / next / last. -->
      <ng-template #pagerTpl let-p let-total="total">
        <div class="mam-pager">
          <div class="mam-pager-size">
            <span>Page Size</span>
            <mat-select
              class="mam-pager-select"
              panelClass="show-by-panel"
              hideSingleSelectionIndicator
              [ngModel]="p.size"
              (ngModelChange)="setPageSize(p, $event)"
            >
              <mat-option *ngFor="let n of pageSizes" [value]="n" class="dropdown_values">{{ n }}</mat-option>
            </mat-select>
          </div>

          <span class="mam-pager-summary">
            <b>{{ pageFirstRow(p, total) }}</b> to <b>{{ pageLastRow(p, total) }}</b> of <b>{{ total }}</b>
          </span>

          <div class="mam-pager-nav">
            <button
              type="button"
              class="mam-pager-btn"
              title="First Page"
              [disabled]="p.index === 0"
              (click)="goToPage(p, 0, total)"
            >
              <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
                <path d="M2 2v8M9.5 2.5L6 6l3.5 3.5" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" />
              </svg>
            </button>
            <button
              type="button"
              class="mam-pager-btn"
              title="Previous Page"
              [disabled]="p.index === 0"
              (click)="goToPage(p, p.index - 1, total)"
            >
              <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
                <path d="M7.5 2.5L4 6l3.5 3.5" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" />
              </svg>
            </button>
            <span class="mam-pager-page">
              Page <b>{{ p.index + 1 }}</b> of <b>{{ pageCount(p, total) }}</b>
            </span>
            <button
              type="button"
              class="mam-pager-btn"
              title="Next Page"
              [disabled]="p.index >= pageCount(p, total) - 1"
              (click)="goToPage(p, p.index + 1, total)"
            >
              <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
                <path d="M4.5 2.5L8 6l-3.5 3.5" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" />
              </svg>
            </button>
            <button
              type="button"
              class="mam-pager-btn"
              title="Last Page"
              [disabled]="p.index >= pageCount(p, total) - 1"
              (click)="goToPage(p, pageCount(p, total) - 1, total)"
            >
              <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
                <path d="M10 2v8M2.5 2.5L6 6l-3.5 3.5" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" />
              </svg>
            </button>
          </div>
        </div>
      </ng-template>

      <!-- KPI card (DPM-Static's .kpi-card: icon, figure, label, help in the corner). -->
      <ng-template #kpiTpl let-k>
          <div class="mam-kpi">
            <app-progress-indefinite class="card-loader" *ngIf="loading"></app-progress-indefinite>

            <ng-container *ngIf="!loading">
              <div class="mam-kpi-info" *ngIf="k.help" [style.--kpi-ring]="k.color">
                <mat-icon
                  svgIcon="info_circle"
                  matTooltip="Help"
                  [matMenuTriggerFor]="cardHelpMenu"
                  (click)="showCardHelp(k)"
                ></mat-icon>
              </div>

              <div class="mam-kpi-body">
                <span class="mam-kpi-icon" [style.color]="k.color" aria-hidden="true">
                  <svg *ngIf="k.cfg.icon === 'pulse'" width="18" height="18" viewBox="0 0 24 24" fill="none">
                    <path d="M3 12h4l3-7 4 14 3-7h4" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                  </svg>
                  <svg *ngIf="k.cfg.icon === 'check'" width="18" height="18" viewBox="0 0 24 24" fill="none">
                    <circle cx="12" cy="12" r="7" stroke="currentColor" stroke-width="1.8" />
                    <path d="M8.8 12.2l2.2 2.2 4.2-4.4" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" />
                  </svg>
                </span>
                <div class="mam-kpi-text">
                  <div class="mam-kpi-value" [style.color]="k.color">{{ kpiText(k) }}</div>
                  <div class="mam-kpi-label">{{ k.cfg.label }}</div>
                  <div class="mam-kpi-target" *ngIf="k.target">{{ k.target }}</div>
                </div>
              </div>
            </ng-container>
          </div>
      </ng-template>

      <!-- Grouped bars / lines (moonlake-series-chart): pages 2 and 4. -->
      <ng-template #seriesCardTpl let-c>
        <div
          class="panel mam-card"
          [attr.data-card-id]="c.widget.id"
          [class.is-fullscreen]="fullscreenId === c.widget.id"
        >
          <div class="mam-head">
            <div class="mam-title">{{ c.widget.title }}</div>

            <div class="mam-controls">
              <div
                class="showByContainer align-items-center w-auto"
                style="text-align: center"
                *ngIf="c.widget.showBy"
              >
                <div class="sort_by_styles d-flex">
                  <label class="sort_by_texts mt-2" style="border-right: 2px solid #e8eaee"
                    >Show by&nbsp;&nbsp;</label
                  >
                  <mat-select
                    class="sort_by_select text-center"
                    panelClass="show-by-panel"
                    hideSingleSelectionIndicator
                    [ngModel]="c.showBy"
                    (ngModelChange)="onSeriesShowByChange(c, $event)"
                  >
                    <mat-option
                      *ngFor="let o of c.showByOptions"
                      [value]="o.value"
                      class="dropdown_values"
                      >{{ o.title }}</mat-option
                    >
                  </mat-select>
                </div>
              </div>
            </div>

            <div class="mam-icons">
              <mat-icon
                *ngIf="c.help"
                class="matIcons"
                svgIcon="info_circle"
                matTooltip="Help"
                [matMenuTriggerFor]="cardHelpMenu"
                (click)="showCardHelp(c)"
              ></mat-icon>

              <mat-icon
                class="matIcons"
                svgIcon="select_setting"
                matTooltip="Settings"
                #sSetTrig="matMenuTrigger"
                [matMenuTriggerFor]="sSetMenu"
                (menuOpened)="openSettings(c)"
              ></mat-icon>
              <mat-menu #sSetMenu="matMenu" class="mam-settings-menu" xPosition="before">
                <div
                  class="mam-set"
                  (click)="$event.stopPropagation()"
                  (keydown)="$event.stopPropagation()"
                >
                  <div class="mam-set-head">
                    <span class="mam-set-title">Settings</span>
                    <button type="button" class="mam-set-x" title="Close" (click)="sSetTrig.closeMenu()">
                      <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
                        <path d="M1 1L11 11M11 1L1 11" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" />
                      </svg>
                    </button>
                  </div>

                  <ng-container *ngIf="c.widget.xAxes.length > 1">
                    <div class="mam-set-sec">X axis</div>
                    <label class="mam-radio" *ngFor="let o of c.widget.xAxes">
                      <input
                        type="radio"
                        [name]="'mam-x-' + c.widget.id"
                        [checked]="c.pendingX === o.key"
                        (change)="c.pendingX = o.key"
                      />
                      <span>{{ o.label }}</span>
                    </label>
                  </ng-container>

                  <div class="mam-set-sec">Y axis</div>
                  <label class="mam-radio" *ngFor="let o of c.widget.yAxes">
                    <input
                      type="radio"
                      [name]="'mam-y-' + c.widget.id"
                      [checked]="c.pendingY === o.key"
                      (change)="c.pendingY = o.key"
                    />
                    <span>{{ o.label }}</span>
                  </label>

                  <div class="mam-set-foot">
                    <button type="button" class="mam-btn mam-btn-ghost" (click)="sSetTrig.closeMenu()">
                      Cancel
                    </button>
                    <button
                      type="button"
                      class="mam-btn mam-btn-primary"
                      (click)="applySettings(c); sSetTrig.closeMenu()"
                    >
                      Apply
                    </button>
                  </div>
                </div>
              </mat-menu>

              <mat-icon
                class="matIcons"
                svgIcon="dotmenu_circle"
                matTooltip="Export"
                [matMenuTriggerFor]="sExportMenu"
              ></mat-icon>
              <mat-menu #sExportMenu="matMenu" class="chart-export-menu mam-export-menu" xPosition="before">
                <button
                  mat-menu-item
                  [disabled]="loading || !c.rows.length || !!outOfScopeFilter(c)"
                  (click)="exportExcel(c)"
                >
                  <mat-icon svgIcon="xls"></mat-icon>
                  <span>Export to Excel</span>
                </button>
                <button mat-menu-item [disabled]="loading" (click)="exportImage(c)">
                  <mat-icon svgIcon="png"></mat-icon>
                  <span>Export to Image</span>
                </button>
              </mat-menu>

              <mat-icon
                class="matIcons"
                [svgIcon]="fullscreenId === c.widget.id ? 'collapse_arrow' : 'expand_circle'"
                [matTooltip]="fullscreenId === c.widget.id ? 'Exit Full Screen' : 'Show Full Screen'"
                (click)="toggleFullscreen(c)"
              ></mat-icon>
            </div>
          </div>

          <div class="panel-state" *ngIf="loading">
            <app-progress-indefinite></app-progress-indefinite>
          </div>

          <div class="panel-state" *ngIf="!loading && outOfScopeFilter(c) as fLabel">
            <span class="bg-text">There is no data for the selected {{ fLabel }}</span>
          </div>

          <ng-container *ngIf="!loading && !outOfScopeFilter(c)">
            <div class="legend-row mam-legend">
              <span
                class="mam-lg-item"
                *ngFor="let l of c.legend; trackBy: trackLegend"
                [class.off]="c.hidden.has(l.key)"
                (click)="toggleSeries(c, l.key)"
              >
                <span
                  class="mam-lg-swatch"
                  [style.background]="c.hidden.has(l.key) ? 'transparent' : l.swatch"
                  [style.border-color]="c.hidden.has(l.key) ? '#b0b0b0' : 'transparent'"
                ></span>
                {{ l.label }}
              </span>
            </div>

            <app-moonlake-series-chart
              [data]="c.rows"
              [config]="c.config"
              [hiddenKeys]="c.hidden"
            ></app-moonlake-series-chart>
          </ng-container>
        </div>
      </ng-template>

      <!-- Stacked bars that open into a waterfall: page 3's parity, page 4's share. -->
      <ng-template #stackedCardTpl let-c>
        <div
          class="panel mam-card"
          [attr.data-card-id]="c.widget.id"
          [class.is-fullscreen]="fullscreenId === c.widget.id"
        >
          <div class="mam-head">
            <div class="mam-title">{{ c.widget.title }}</div>
            <div class="mam-controls">
              <div
                class="showByContainer align-items-center w-auto"
                style="text-align: center"
                *ngIf="c.kind === 'share'"
              >
                <div class="sort_by_styles d-flex">
                  <label class="sort_by_texts mt-2" style="border-right: 2px solid #e8eaee"
                    >Show by&nbsp;&nbsp;</label
                  >
                  <mat-select
                    class="sort_by_select text-center"
                    panelClass="show-by-panel"
                    hideSingleSelectionIndicator
                    [ngModel]="c.showBy"
                    (ngModelChange)="onShareShowByChange(c, $event)"
                  >
                    <mat-option *ngFor="let o of c.widget.measures" [value]="o.key" class="dropdown_values">{{
                      o.title
                    }}</mat-option>
                  </mat-select>
                </div>
              </div>
            </div>

            <div class="mam-icons">
              <mat-icon
                *ngIf="c.help"
                class="matIcons"
                svgIcon="info_circle"
                matTooltip="Help"
                [matMenuTriggerFor]="cardHelpMenu"
                (click)="showCardHelp(c)"
              ></mat-icon>

              <mat-icon
                class="matIcons"
                svgIcon="select_setting"
                matTooltip="Settings"
                #pSetTrig="matMenuTrigger"
                [matMenuTriggerFor]="pSetMenu"
                (menuOpened)="openSettings(c)"
              ></mat-icon>
              <mat-menu #pSetMenu="matMenu" class="mam-settings-menu" xPosition="before">
                <div
                  class="mam-set"
                  (click)="$event.stopPropagation()"
                  (keydown)="$event.stopPropagation()"
                >
                  <div class="mam-set-head">
                    <span class="mam-set-title">Settings</span>
                    <button type="button" class="mam-set-x" title="Close" (click)="pSetTrig.closeMenu()">
                      <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
                        <path d="M1 1L11 11M11 1L1 11" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" />
                      </svg>
                    </button>
                  </div>

                  <div class="mam-set-sec">X axis</div>
                  <label class="mam-radio" *ngFor="let o of c.widget.xAxes">
                    <input
                      type="radio"
                      [name]="'mam-x-' + c.widget.id"
                      [checked]="c.pendingX === o.key"
                      (change)="c.pendingX = o.key"
                    />
                    <span>{{ o.label }}</span>
                  </label>

                  <div class="mam-set-sec">Y axis</div>
                  <label class="mam-radio" *ngFor="let o of yOptionsFor(c)">
                    <input
                      type="radio"
                      [name]="'mam-y-' + c.widget.id"
                      [checked]="c.pendingY === o.key"
                      (change)="c.pendingY = o.key"
                    />
                    <span>{{ o.label }}</span>
                  </label>

                  <div class="mam-set-foot">
                    <button type="button" class="mam-btn mam-btn-ghost" (click)="pSetTrig.closeMenu()">
                      Cancel
                    </button>
                    <button
                      type="button"
                      class="mam-btn mam-btn-primary"
                      (click)="applySettings(c); pSetTrig.closeMenu()"
                    >
                      Apply
                    </button>
                  </div>
                </div>
              </mat-menu>

              <mat-icon
                class="matIcons"
                svgIcon="dotmenu_circle"
                matTooltip="Export"
                [matMenuTriggerFor]="pExportMenu"
              ></mat-icon>
              <mat-menu #pExportMenu="matMenu" class="chart-export-menu mam-export-menu" xPosition="before">
                <button mat-menu-item [disabled]="loading || !c.rows.length" (click)="exportExcel(c)">
                  <mat-icon svgIcon="xls"></mat-icon>
                  <span>Export to Excel</span>
                </button>
                <button mat-menu-item [disabled]="loading" (click)="exportImage(c)">
                  <mat-icon svgIcon="png"></mat-icon>
                  <span>Export to Image</span>
                </button>
              </mat-menu>

              <mat-icon
                class="matIcons"
                [svgIcon]="fullscreenId === c.widget.id ? 'collapse_arrow' : 'expand_circle'"
                [matTooltip]="fullscreenId === c.widget.id ? 'Exit Full Screen' : 'Show Full Screen'"
                (click)="toggleFullscreen(c)"
              ></mat-icon>
            </div>
          </div>

          <div class="panel-state" *ngIf="loading">
            <app-progress-indefinite></app-progress-indefinite>
          </div>

          <ng-container *ngIf="!loading">
            <div class="legend-row mam-legend">
              <span
                class="mam-lg-item"
                *ngFor="let l of c.legend; trackBy: trackLegend"
                [class.off]="c.hidden.has(l.key)"
                (click)="toggleSeries(c, l.key)"
              >
                <span
                  class="mam-lg-swatch"
                  [style.background]="c.hidden.has(l.key) ? 'transparent' : l.swatch"
                  [style.border-color]="c.hidden.has(l.key) ? '#b0b0b0' : 'transparent'"
                ></span>
                {{ l.label }}
              </span>
            </div>

            <app-moonlake-waterfall-chart
              [data]="c.rows"
              [config]="c.config"
              [hiddenKeys]="c.hidden"
              (viewChange)="fullscreenId === c.widget.id && refitFullView()"
            ></app-moonlake-waterfall-chart>
          </ng-container>
        </div>
      </ng-template>

    </div>
  </div>

  <!-- ===================== RIGHT FILTER PANEL (as on DPM-Static) ========== -->
  <div class="filter-panel-backdrop" *ngIf="filterPanelOpen" (click)="closeFilterPanel()"></div>

  <aside class="filter-panel" [class.open]="filterPanelOpen" #fpEl [style.width.px]="panelWidth">
    <div
      class="fp-resize"
      (resize)="onResizeSide($event)"
      [targetElement]="fpEl"
      [direction]="AngularResizeElementDirection.LEFT"
      title="Drag to resize"
    ></div>

    <div class="fp-toggle" (click)="toggleFilterPanel()" [title]="filterPanelOpen ? 'Close' : 'Filter'">
      <mat-icon *ngIf="!filterPanelOpen" svgIcon="g_filter"></mat-icon>
      <span *ngIf="filterPanelOpen" class="fp-toggle-x">✕</span>
    </div>

    <h2 class="fp-title">Filter</h2>
    <hr class="fp-hr" />

    <div class="fp-body">
      <ng-container *ngFor="let f of filters; trackBy: trackFilter">
        <div class="fp-field" *ngIf="hasOptions(f)">
          <label class="filterLabelStyle">{{ f.label }}</label>

          <!-- DISPLAY (Therapeutic Class) — states the class, nothing to pick. -->
          <div class="fp-static" *ngIf="f.kind === 'display'" [title]="f.note">
            {{ f.options.join(", ") }}
          </div>

          <!-- TREE (Payer) — opens the strip's tree dropdown, over the panel. -->
          <div class="fp-static fp-trigger" *ngIf="f.kind === 'tree'" (click)="toggleDropdown(f, $event)">
            <span>{{ chipValue(f) }}</span>
            <span class="fp-caret">▾</span>
          </div>

          <!-- SINGLE SELECT (a filter configured `single`) — the pick applies, the list closes. -->
          <ng-select
            *ngIf="f.kind === 'list' && f.single"
            #scS
            class="ngSelection fp-select"
            [multiple]="false"
            [clearable]="false"
            [closeOnSelect]="true"
            [dropdownPosition]="'auto'"
            [appendTo]="'.filter-panel'"
            [items]="f.options"
            [ngModel]="f.checked[0] || null"
            (ngModelChange)="onSingleModel(f, $event)"
            (close)="onSelectClose(f)"
            [placeholder]="filterPlaceholder(f)"
          >
            <ng-template ng-header-tmp>
              <input
                class="searchFiler"
                type="text"
                placeholder="Search"
                (input)="scS.filter(onFilterText(f, $event))"
              />
            </ng-template>
            <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
              <div class="form-check du-opt">
                <input
                  style="accent-color: #1363df !important"
                  id="mam-opt-s-{{ index }}"
                  type="checkbox"
                  [checked]="item$.selected"
                />
                <label class="form-check-label">{{ item }}</label>
              </div>
            </ng-template>
          </ng-select>

          <!-- MULTI SELECT -->
          <ng-select
            *ngIf="f.kind === 'list' && !f.single"
            #scM
            class="ngSelection fp-select"
            [multiple]="true"
            [clearable]="false"
            [closeOnSelect]="false"
            [dropdownPosition]="'auto'"
            [appendTo]="'.filter-panel'"
            [items]="f.options"
            [ngModel]="f.checked"
            (ngModelChange)="f.checked = $event"
            (close)="onSelectClose(f)"
            [placeholder]="filterPlaceholder(f)"
          >
            <ng-template ng-header-tmp>
              <input
                class="searchFiler"
                type="text"
                placeholder="Search"
                (input)="scM.filter(onFilterText(f, $event))"
              />
              <div class="form-check multiselect-form-check">
                <input
                  style="accent-color: #1363df !important"
                  type="checkbox"
                  [checked]="allChecked(f)"
                  (click)="toggleSelectAll(f, $event)"
                />
                <label class="form-check-label">
                  <span *ngIf="!f.search">Select All</span>
                  <span *ngIf="f.search">(Select All Search Results)</span>
                </label>
              </div>
              <div class="form-check multiselect-form-check">
                <input
                  style="accent-color: #1363df !important"
                  type="checkbox"
                  [checked]="f.addCurrent"
                  (click)="toggleAddCurrent(f, $event)"
                />
                <label class="form-check-label">Add current selection to filter</label>
              </div>
            </ng-template>

            <ng-template ng-multi-label-tmp let-items="items">
              <div class="ng-value" *ngFor="let it of items | slice: 0 : itemsShowLimit">
                <span class="ng-value-label">{{ it }}</span>
              </div>
              <div class="ng-value" *ngIf="items.length > itemsShowLimit">
                <span class="ng-value-label">{{ items.length - itemsShowLimit }} more...</span>
              </div>
            </ng-template>

            <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
              <div class="form-check du-opt">
                <input
                  style="accent-color: #1363df !important"
                  id="mam-opt-m-{{ index }}"
                  type="checkbox"
                  [checked]="item$.selected"
                />
                <label class="form-check-label">{{ item }}</label>
              </div>
            </ng-template>

            <ng-template ng-footer-tmp>
              <div class="d-flex align-items-center py-2" style="gap: 10px">
                <ng-container *ngTemplateOutlet="ieButtons; context: { f: f, sc: scM }"></ng-container>
              </div>
            </ng-template>
          </ng-select>
        </div>
      </ng-container>

      <div class="fp-field" *ngIf="quarters.length">
        <label class="filterLabelStyle">{{ dateLabel }}</label>
        <div class="fp-static fp-trigger" (click)="togglePeriod($event)">
          <span>{{ periodLabel(period) }}</span>
          <span class="fp-caret">▾</span>
        </div>
      </div>

      <hr class="fp-hr" />

      <div class="fp-reset-row" *ngIf="anyPartial">
        <span class="fp-reset-chip" (click)="resetFilters()">
          <mat-icon class="reset-icon" svgIcon="x_mark"></mat-icon>Reset
        </span>
      </div>
    </div>
  </aside>

  <!-- Card help popover — the same .card markup DPM-Static's KPI help uses. -->
  <mat-menu #cardHelpMenu="matMenu" class="kpi-info-menu mam-help-menu">
    <div
      class="card"
      style="min-width: 300px; max-width: 420px; border: none; width: auto"
      (click)="$event.stopPropagation()"
    >
      <div
        class="card-header d-flex justify-content-between align-items-center"
        style="border-bottom: none; background: #ddd"
      >
        <span style="font-weight: 600">{{ cardHelp?.info_header }}</span>
        <span style="cursor: pointer" (click)="cardHelpMenu.closed.emit()">
          <svg width="12" height="12" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M12.9501 0.409871L8 5.35998L3.04989 0.409871C2.5034 -0.136624 1.61634 -0.136624 1.06985 0.409871L0.409871 1.06985C-0.136624 1.61634 -0.136624 2.5034 0.409871 3.04989L5.35998 8L0.409871 12.9501C-0.136624 13.4966 -0.136624 14.3837 0.409871 14.9302L1.06985 15.5901C1.61634 16.1366 2.5034 16.1366 3.04989 15.5901L8 10.64L12.9501 15.5901C13.4966 16.1366 14.3837 16.1366 14.9302 15.5901L15.5901 14.9302C16.1366 14.3837 16.1366 13.4966 15.5901 12.9501L10.64 8L15.5901 3.04989C16.1366 2.5034 16.1366 1.61634 15.5901 1.06985L14.9302 0.409871C14.3837 -0.136624 13.4966 -0.136624 12.9501 0.409871Z"
              fill="#1363DF"
            />
          </svg>
        </span>
      </div>
      <div class="card-body">
        <div [innerHtml]="cardHelp?.info_text || ''"></div>
      </div>
    </div>
  </mat-menu>
</div>
